<template>
  <div>
    <div class="page_title">角色权限设置</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div style="text-align: left; margin-bottom: 15px">
          <span>角色名</span>
          <span class="rolename">{{ group_name }}</span>
        </div>

        <!-- 角色权限配置 -->
        <div>
          <div
            class="role"
            v-for="(role1, index) in roleData"
            :key="index"
          >
            <div
              class="role1"
              @click="chooseRole1(role1, index)"
            >
              <img
                src="@/assets/img/system/not_check.png"
                alt
                v-if="!role1.isChecked"
              />
              <img
                src="@/assets/img/system/check.png"
                alt
                v-if="role1.isChecked"
              />
              <span>{{ role1.module_name }}</span>
            </div>
            <div class="role2">
              <div
                class="role2_item"
                v-for="(role2, ind) in role1.list"
                :key="ind"
              >
                <div
                  class="role2_item1"
                  @click="chooseRole2(role1, role2, index, ind)"
                >
                  <img
                    src="@/assets/img/system/not_check.png"
                    alt
                    v-if="!role2.isChecked"
                  />
                  <img
                    src="@/assets/img/system/check.png"
                    alt
                    v-if="role2.isChecked"
                  />
                  <span>{{ role2.module_name }}</span>
                </div>
                <div class="role2_item2">
                  <div
                    v-for="(role3, i) in role2.list"
                    :key="i"
                    @click="chooseRole3(role1, role2, role3, index, ind, i)"
                  >
                    <img
                      src="@/assets/img/system/not_check.png"
                      alt
                      v-if="!role3.isChecked"
                    />
                    <img
                      src="@/assets/img/system/check.png"
                      alt
                      v-if="role3.isChecked"
                    />
                    <span>{{ role3.module_name }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="margin: 30px 0 24px; text-align: left">
          <el-button
            type="primary"
            round
            style="width: 92px"
            @click="submitRole"
          >保存</el-button>
          <el-button
            plain
            round
            style="width: 92px"
            @click="back"
          >退出</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import system from '../../../api/system';
import _ from 'lodash';

export default {
  data() {
    return {
      group_name: this.$route.query.group_name,
      roleData: [],
      role: {}
    };
  },
  methods: {
    getModuleList() {
      system
        .ModuleList()
        .then((res) => {
          if (res.code == 0) {
            let data = res.data.list;
            data.forEach((item) => {
              item.isChecked = false;
              if (item.list && item.list.length) {
                item.list.forEach((i) => {
                  i.isChecked = false;
                  if (i.list && i.list.length) {
                    i.list.forEach((j) => {
                      j.isChecked = false;
                    });
                  }
                });
              }
            });
            this.roleData = data;
            let that = this;
            if (that.$route.query.module_id_array) {
              let rolelist = that.$route.query.module_id_array;
              let check_id = rolelist.split(',');
              that.roleData.forEach((item) => {
                if (check_id.includes(item.module_id + '')) {
                  item.isChecked = true;
                }
                if (item.list && item.list.length) {
                  item.list.forEach((i) => {
                    if (check_id.includes(i.module_id + '')) {
                      i.isChecked = true;
                    }
                    if (i.list && i.list.length) {
                      i.list.forEach((j) => {
                        if (check_id.includes(j.module_id + '')) {
                          j.isChecked = true;
                        }
                      });
                    }
                  });
                }
              });
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //选择一级角色
    chooseRole1(role1, index) {
      if (this.$route.query.group_id == 1) {
        return false;
      }
      role1.isChecked = !role1.isChecked;
      if (role1.isChecked) {
        if (this.roleData[index].list && this.roleData[index].list.length) {
          this.roleData[index].list.forEach((i) => {
            i.isChecked = true;
            if (i.list && i.list.length) {
              i.list.forEach((j) => {
                j.isChecked = true;
              });
            }
          });
        }
      } else {
        if (this.roleData[index].list && this.roleData[index].list.length) {
          this.roleData[index].list.forEach((i) => {
            i.isChecked = false;
            if (i.list && i.list.length) {
              i.list.forEach((j) => {
                j.isChecked = false;
              });
            }
          });
        }
      }
    },
    //选择二级角色
    chooseRole2(role1, role2, index, ind) {
      if (this.$route.query.group_id == 1) {
        return false;
      }
      role2.isChecked = !role2.isChecked;
      role1.isChecked = false;
      if (role2.list && role2.list.length) {
        role2.list.forEach((ele) => {
          ele.isChecked = role2.isChecked;
        });
      }
      this.roleData[index].list.forEach((i) => {
        let a = 0;
        if (i.isChecked) {
          a = 1;
        }
        if (a) {
          role1.isChecked = true;
        }
      });
    },
    //选择三级角色
    chooseRole3(role1, role2, role3, index, ind) {
      if (this.$route.query.group_id == 1) {
        return false;
      }
      role3.isChecked = !role3.isChecked;
      role1.isChecked = false;
      role2.isChecked = false;
      this.roleData[index].list[ind].list.forEach((i) => {
        let a = 0;
        if (i.isChecked) {
          a = 1;
        }
        if (a) {
          role2.isChecked = true;
        }
      });
      this.roleData[index].list.forEach((i) => {
        let a = 0;
        if (i.isChecked) {
          a = 1;
        }
        if (a) {
          role1.isChecked = true;
        }
      });
    },
    //提交选择的角色分配
    submitRole() {
      let check_id = [];
      this.roleData.map((item) => {
        if (item.isChecked) {
          check_id.push(item.module_id);
        }
        if (item.list && item.list.length) {
          item.list.map((i) => {
            if (i.isChecked) {
              check_id.push(i.module_id);
            }
            if (i.list && i.list.length) {
              i.list.map((j) => {
                if (j.isChecked) {
                  check_id.push(j.module_id);
                }
              });
            }
          });
        }
      });
      let module_id_array = check_id.toString();
      let group_id = this.$route.query.group_id;
      system
        .setModule({ group_id, module_id_array })
        .then((res) => {
          if (res.code == 0) {
            this.$message.success('设置成功');
            history.back();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //退出
    back() {
      this.$confirm('是否放弃设置角色权限？', '提示消息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          history.back();
        })
        .catch(() => {});
    }
  },
  created() {
    this.getModuleList();
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}

.rolename {
  display: inline-block;
  height: 23px;
  background-color: #e5f5e4;
  border-radius: 2px;
  margin-left: 20px;
  color: #669961;
  padding: 2px 5px;
}

.role:first-child {
  border-top: 1px solid #cfcece;
}
.role {
  width: 100%;
  display: flex;
  border: 1px solid #cfcece;
  border-top: 1px solid transparent;
  justify-content: space-between;
  span {
    margin-left: 5px;
  }
  .role1 {
    line-height: 45px;
    width: 170px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid #cfcece;
    cursor: pointer;
  }
  .role2 {
    flex: 1;
    .role2_item {
      display: flex;
      border-bottom: 1px solid #cfcece;
      .role2_item1 {
        width: 200px;
        border-right: 1px solid #cfcece;
        line-height: 45px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
      .role2_item2 {
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        div {
          line-height: 45px;
          padding: 0 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 10px;
          cursor: pointer;
        }
      }
    }
    .role2_item:last-child {
      border-bottom: 1px solid transparent;
    }
  }
}
</style>